import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
import { Subject } from 'rxjs';
import { ApiService } from 'src/app/Services/api.service';
import { StorageService } from 'src/app/Services/storage.service';
import { FormBuilder, FormGroup } from '@angular/forms';

declare const Swal;

@Component({
  selector: 'g10-organization-view-notifications',
  templateUrl: './view-notifications.component.html',
  styleUrls: ['./view-notifications.component.css']
})
export class ViewNotificationsComponent implements OnInit {
  @ViewChild('modalShow') modalShow;
  @ViewChild('modalHide') modalHide;

  public notificationObj=[];
  public tableData = [];
  public vehicleObj=[];
  public editNotificationId;
  public editNotificationObj={};
  public notificationConfigData={};
  public noDataEnable:boolean = false;
  public notifications=[
/*     {
      notificationID:2341,
      title:"OverSpeed",
      type:["sms","email","call","push notifications"],
      mobile:["9812341234","9182341123"],
      vehicles:["60f66b0826aa652f099fb282","60f66b1e26aa652f099fb283","60f66b2e26aa652f099fb284"],
      timeFor:"8:00 AM",
      timeTill:"5:00 PM",
      speedFrom:60,
      speedTill:80,
      email:['test@gmail.com']
      },
    {
      notificationID:2342,
      title:"geofence",
      type:["email"],
      email:["test@groupten.com","test1@groupten.com"],
      vehicles:["60f66b4926aa652f099fb285"],
      geofence:"Guindy Railway Station,chennai,tamilnadu,India.",
      timeFor:"12:40 PM",
      timeTill:"10:00 PM",
      },
      {
        notificationID:2343,
        title:"halt",
        type:["email"],
        email:["test3@groupten.com"],
        vehicles:["all"],
        timeFor:"12:40 PM",
        timeTill:"10:00 PM",
      } */
  ];
  // public notifications=[];
  public searchInput: any = new Subject<string>();
  public searchedValue: any;
  public orgID;

  public modalTitle;
  public modalType;
  public editNotificationData;
  public filterEnable:boolean=false;
  public activeIndex;
  public activeSelection={};

  public filteredData = [];

  public fieldOptions={
    title:[
      'panic','overspeed','halt'
      ],
      type:['sms','email','push'],
      vehicles:[

      ],
    };
  public searchForm:FormGroup;

  public objKeys = Object.keys;

  public closeAddSettings:boolean = true;
  public closeEditSettings:boolean = true;

  constructor(
    public api: ApiService,
    public storage: StorageService,
    public router: Router,
    public swal: SweetAlert,
    public fb: FormBuilder,
    ) {
      this.orgID= this.storage.get('userInfo').orgID;
    }

  ngOnInit(): void {
    this.searchFormLoad();
    this.getVehicleList();
    this.getNotificationConfigData('email');
    this.getNotificationConfigData('mobile');
    this.getNotificationList();
  }
  notificationModal(modalType){
    if(modalType=='add'){
      this.modalTitle='Add Notification Setting';
      // this.modalType=modalType;
      // this.modalShow.nativeElement.click();
      this.closeAddSettings = false;
    }
    if(modalType=='edit'){
      this.modalTitle='Edit Notification Setting';
      this.closeEditSettings = false;
    /*   this.modalType=modalType;
      this.modalShow.nativeElement.click(); */
    }
  }
  modalClose(){
    this.modalTitle='';
    this.modalType='';
    this.editNotificationId=undefined;
    this.editNotificationObj={};
    this.modalHide.nativeElement.click();
  }
  /* API */
  getNotificationList() {
    const obj = {
      orgID: this.orgID
    };
    this.api.transportManagerNotificationSettingList(obj).then((res: any) => {
      // console.log(res);
      if (res.status == 'success') {
        this.notificationObj = res.data;
        this.tableData = [ ...this.notificationObj];
        this.notificationObj.filter((e)=>{
          this.filterOptions(e['title'],'title');
          this.filterOptions(e['vehicles'],'vehicles');
        })
      }
      setTimeout(()=>{  this.noDataEnable = true; },300);
    }).catch((err) => {
      console.log(err);
    });
  }

  filterOptions(data,key){

    if (key!='title'){
        data?.filter((element)=>{
          if (this.fieldOptions[key].length>0) this.pushOptions(key,element);
          else this.fieldOptions[key].push(element);
        });
    }
    else{
      if (this.fieldOptions[key].length>0) this.pushOptions(key,data);
      else this.fieldOptions[key].push(data);
    }

  }

  pushOptions(key,data){
    let duplicate = this.fieldOptions[key].indexOf(data) == -1;
    if (duplicate){
      if(data == 'all') this.fieldOptions[key].unshift(data);
      else this.fieldOptions[key].push(data);
    }
  }

  getVehicleList(){
    let obj = {
      orgID: this.orgID,
    }
    this.api.transportManagerVehicleList(obj).then((res:any)=>{
      if (res.status == 'success') {
      this.vehicleObj=res.data;
      }
    }).catch((err) => {
      console.log(err)
    })
  } 
  // get Mobile and Email from api
  getNotificationConfigData(dataType) {
    const obj = {
      orgID: this.orgID,
      type:"list",
      notification:dataType,
    };
    this.api.transportManagerNotificationConfig(obj).then((res: any) => {
      if (res.status == 'success') {
        this.notificationConfigData[dataType]=res.data;
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  fieldChange(){
    this.filteredData = [ ...this.notificationObj];
    this.tableData = [ ...this.notificationObj];
    Object.entries(this.searchForm.value).forEach(([key, value]) => {
      if (value)  this.filterNotification(key,value);  });
  }

  filterNotification(key,value){
      if (key=='title'){

        this.filteredData = this.filteredData.filter((e)=>{
          if(e['title']==value) return e;   });

      }
      if (key=='type'){

        this.filteredData = this.filteredData.filter((e)=>{
          if(e[value] && e[value].length > 0) return e;  });
      }
      if (key=='vehicles'){
        this.filteredData = this.filteredData.filter((e)=>{
          let isVehicleFound = false;
          e[key].filter((val)=>{
            if(value =='all' && val =='all') isVehicleFound=true;
            //let vehicle = this.filteredvehicle(val);
            /*  console.log(vehicle,val,e,value);
            if(vehicle['vehRegNo'].toLowerCase().includes(value.toLowerCase()))
            return true; */
            if(value !='all' && val !='all'){
              let vehicle = this.vehicleObj.filter((vehicle)=> vehicle.vehicleID==val );
              if (vehicle[0]['vehicleID'] == value ) isVehicleFound=true;
            }
          })
          if(isVehicleFound) return e;
        });
      }
      this.tableData = [ ...this.filteredData];
  }
  filteredvehicle(vehicleID){
    this.vehicleObj.filter((vehicle)=>{
        if (vehicle.vehicleID==vehicleID) return vehicle; 
    })
  }
  resetFilter(){
    this.tableData = [ ...this.notificationObj];
  }

  searchFormLoad(){
    this.searchForm=this.fb.group({
      title:[''],
      type:[''],
      vehicles:[''],
    })
  }
/* get obj from id*/
getVehicleObj(id){
  let objId=[id];
  let obj=this.getObjData(this.vehicleObj,'vehicleID',objId);
  if(obj && obj[0]) return obj[0].vehRegNo;
  else return '';
}
getObjData(obj,typeOfID,id){
  let result=[];
  id.filter((val)=>{
    obj.filter((element)=>{
      if(element[typeOfID]==val){
        result.push(element);
      }
    })
  });
  return result;
}

/* Expand Table */
  expandMore(index){
    if(this.tableData.length>0){
      let obj=this.tableData[index];
      this.activeSelection=obj;
      this.activeIndex=index;
    }
  }
  expandLess(){
    this.activeIndex=undefined;
    this.activeSelection={};
  }
  /* Get Mobile Number from given notificationID*/

  getEmailID(ID,key){
    let result=[];
    this.notificationConfigData['email'].filter((element)=>{
      if (element['notificationID']==ID) result.push(element);
    });
    if (result && result.length>0 ) return result[0][key];
    else return '---';
  }
  
  /* Get Mobile Number from given notificationID*/
  
  getMobileNo(ID,key){
    let result=[];
    this.notificationConfigData['mobile'].filter((element)=>{
      if (element['notificationID']==ID) result.push(element);
    });
    if (result && result.length>0 ) return result[0][key];
    else return '---';
  }

  editNotification(obj){
    this.editNotificationId=obj.notificationID;
    this.editNotificationObj=obj;
    this.notificationModal('edit');
  }
  createNotificationSetting(e){
    this.api.transportManagerNotificationSettingCreate(e).then((res: any) => {
      if (res.status == 'success') {
        this.getNotificationList();
        this.swal.swalFunction(res.status, res.status, res.message, 20000);
      }
      if (res.status == 'failure') {
        this.swal.swalFunction('error', res.status, res.message, 20000);
      }
    });
    this.modalClose();
  }
  editNotificationSetting(editObj){
    let obj=this.checkUpdateValues(editObj);
    if(obj){
      this.api.transportManagerNotificationSettingUpdate(obj).then((res: any) => {
      if (res.status == 'success') {
        this.getNotificationList();
        this.swal.swalFunction(res.status, res.status, res.message, 20000);
      }
      if (res.status == 'failure') {
        this.swal.swalFunction('error', res.status, res.message, 20000);
      }
    });
    this.modalClose();
    }
  }

  checkUpdateValues(e){
    let updateValues={};
    let keys=Object.keys(e);
    keys.filter((key)=>{
      if(this.editNotificationObj[key]!=e[key]){
        updateValues[key]=e[key];      
      }
    })
    if(Object.keys(updateValues).length>0){
      let obj={
        orgID:this.editNotificationObj['orgID'],
        notificationID:this.editNotificationObj['notificationID'],
        ...updateValues,
      };
      return obj;
    }
    else return undefined;
  }

  delete(id) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor:  '#d33',//'#3085d6',
      //  cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.deleteNotification(id);
        Swal.fire(
          'Deleted!',
          'Your file has been deleted.',
          'success'
        );
      }
    });
  }
  deleteNotification(notificationID){
    let obj={
      orgID:this.orgID,
      notificationID:notificationID,
    }
    this.api.transportManagerNotificationSettingDelete(obj).then((res: any) => {
      if (res.status == 'success') {
        this.swal.swalFunction(res.status, res.status, res.message, 20000);
        this.getNotificationList();
      }
      if (res.status == 'failure') {
        this.swal.swalFunction('error', res.status, res.message, 20000);
      }
    });
  } 

}
